import Page from "../Page";
import { useAccess } from "src/hooks/useAccess.hook";
import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BaseTable } from "../BaseTable/BaseTable";
import { useList } from "src/hooks/useFetch.hook";
import { FEATURE } from "src/util/enums";
import { companyListColumns } from "./company.constants";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------

const StyledListCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadiusMd,
  boxShadow: theme.customShadows.z4,
  border: `1px solid ${theme.palette.success.light}40`,
  background: `linear-gradient(135deg, ${theme.palette.success.lighter}08 0%, ${theme.palette.success.light}05 100%)`,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: `0 8px 25px ${theme.palette.success.light}20`,
    border: `1px solid ${theme.palette.success.light}60`,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '3px',
    background: `linear-gradient(90deg, ${theme.palette.success.main} 0%, ${theme.palette.success.light} 100%)`,
    borderRadius: `${theme.shape.borderRadiusMd}px ${theme.shape.borderRadiusMd}px 0 0`,
  },
}));

export const CompanyList = () => {
  const navigate = useNavigate()
  const hasCreateAccess = useAccess(FEATURE.COMPANY, "C");
  const isReadOnly = useAccess(FEATURE.COMPANY, "R");
  const { data: company, isFetching } = useList("companyList");
  const rowOrCellClickRedirect = ({ id }) => {
    if(isReadOnly) return;
    navigate(`/company/${id}`);
  };
  return (
    <Page

      {...(hasCreateAccess && { path: `/company/new` })}
      actionButtonText="Add Company"
    >
      <StyledListCard>
        <BaseTable
          rows={company ?? []}
          columns={companyListColumns(isReadOnly)}
          loading={isFetching}
          getRowId={(row) => row.teamId}
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          isReadOnly={isReadOnly}
        />
      </StyledListCard>
    </Page>
  );
};
